import { Component, Input, OnInit, Output, EventEmitter, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { SELECTORS } from '@root/app.config';
import { PassDataService } from '@core/services/pass-data/pass-data.service';
import { Material } from '@root/app.interfaces';

@Component({
	selector: 'app-color-picker',
	templateUrl: './color-picker.component.html',
	styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent implements OnInit, OnDestroy {
	@Input() colors;
	@Input() data: Material;
	@Input() placement;
	@Output() setColorData = new EventEmitter();
	@ViewChild('colorPickerPopover') colorPickerPopover: NgbPopover;

	isMobile = this.passDataService.isMobileOrTablet;
	scrollSelector = this.isMobile ? SELECTORS.blind_list : SELECTORS.simplebar_content_wrapper;

	@HostListener('click', ['$event']) onClick(event: MouseEvent) {
		event.stopPropagation();
	}

	constructor(private passDataService: PassDataService) {}

	ngOnInit(): void {
		document.querySelector(this.scrollSelector)?.addEventListener('scroll', this.onDocumentScroll.bind(this));
	}

	ngOnDestroy(): void {
		document.querySelector(this.scrollSelector)?.removeEventListener('scroll', this.onDocumentScroll);
	}

	onChangeColor({ color, name }): void {
		if (color && name && color !== this.data.color) {
			this.data.color = color;
			this.data.color_name = name;
			this.setColorData.emit(this.data);
		}

		if (this.isMobile) {
			this.colorPickerPopover.close();
		}
	}

	onDocumentScroll(event: Event): void {
		const popoverParent = this.colorPickerPopover['_nativeElement'];
		const toolBar = event.target as HTMLElement;
		const popoverParentRect = popoverParent.getBoundingClientRect();
		const toolBarRect = toolBar.getBoundingClientRect();

		if (
			(popoverParentRect.top && popoverParentRect.top < toolBarRect.top) ||
			(popoverParentRect.bottom && popoverParentRect.bottom > toolBarRect.bottom)
		) {
			this.colorPickerPopover.close();
		}
	}

	open(): void {
		this.colorPickerPopover.open();
	}
}
